module.exports = __webpack_public_path__ + "static/media/Sector3.fa3fe9a5.jpg";